import axios from 'axios'
import { getFirstErrorMessage } from '~/lib/axios'

export default {
  name: 'unsubscribe-button',

  props: {
    email: {
      type: String,
      default: '',
    },
    successLabel: {
      type: String,
      default: 'Unsubscribed',
    },
  },

  data: () => ({
    form: {
      email: ''
    },
    unsubscribing: false,
    unsubscribed: false,
    errorMessage: null,
  }),

  created() {
    const url = new URL(window.location.href)
    const query = Object.fromEntries(url.searchParams.entries())

    this.form.email = this.email || query.email
  },

  methods: {
    async unsubscribe () {
      try {
        this.errorMessage = null
        this.unsubscribing = true
        await axios.post(`${window.addiesaas.url}/api/user/unsubscribe`, this.form)
        this.unsubscribed = true
      } catch (e) {
        this.errorMessage = getFirstErrorMessage(e)
      } finally {
        this.unsubscribing = false
      }
    }
  }
}
